const _unique = definitions => {
  const names = {};
  return definitions.filter(definition => {
    if (definition.kind !== 'FragmentDefinition') {
      return true;
    }
    const name = definition.name.value;
    if (names[name]) {
      return false;
    } else {
      names[name] = true;
      return true;
    }
  });
};
import { gql } from '@apollo/client';
const FETCH_ASSOCIATED_OBJECTS_CARD_ASSOCIATIONS_CRM_SEARCH_PAYLOAD_FRAGMENT = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"FragmentDefinition\",\"name\":{\"kind\":\"Name\",\"value\":\"FetchAssociatedObjectsCardAssociationsCrmSearchPayload\"},\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"CrmSearchPayload\"}},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"hasMore\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"offset\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"total\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"results\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"userPermissions\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"currentUserCanView\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"currentUserCanEdit\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"allProperties\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"name\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"value\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"primaryDisplayProperty\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"name\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"value\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"definition\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"type\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"name\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"deleted\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"textDisplayHint\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"showCurrencySymbol\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"dataSensitivity\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"currencyPropertyName\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"label\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"fieldType\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"formField\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"hidden\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"hubspotDefined\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"groupName\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"externalOptions\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"externalOptionsReferenceType\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"displayOrder\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"displayMode\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"description\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"calculated\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"objectTypeId\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"readOnlyDefinition\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"readOnlyValue\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"referencedObjectType\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"numberDisplayHint\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"mutableDefinitionNotDeletable\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"options\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"description\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"displayOrder\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"doubleData\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"hidden\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"label\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"readOnly\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"value\"}}]}}]}}]}},{\"kind\":\"InlineFragment\",\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Contact\"}},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"defaultAssociations\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"toCompanies\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"first\"},\"value\":{\"kind\":\"IntValue\",\"value\":\"1\"}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"edges\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"node\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"defaultProperties\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"name\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"value\"}}]}}]}}]}}]}}]}}]}}]}},{\"kind\":\"InlineFragment\",\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Ticket\"}},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"pipelineInfo\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"pipeline\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"pipelineId\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"stages\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"label\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"displayOrder\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"stageId\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"metadata\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"propertyValueRequirements\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"isValueRequired\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"propertyName\"}}]}}]}}]}}]}}]}},{\"kind\":\"InlineFragment\",\"typeCondition\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Deal\"}},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"pipelineInfo\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"pipeline\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"pipelineId\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"stages\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"label\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"displayOrder\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"stageId\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"metadata\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"propertyValueRequirements\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"isValueRequired\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"propertyName\"}}]}}]}}]}}]}}]}}]}}]}}]}", {
  kind: "Document",
  definitions: [{
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "FetchAssociatedObjectsCardAssociationsCrmSearchPayload"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "CrmSearchPayload"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "hasMore"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "offset"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "total"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "results"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "userPermissions"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "currentUserCanView"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "currentUserCanEdit"
                }
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "allProperties"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "id"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "name"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "value"
                }
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "primaryDisplayProperty"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "id"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "name"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "value"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "definition"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "type"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "name"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "deleted"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "textDisplayHint"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "showCurrencySymbol"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "dataSensitivity"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "currencyPropertyName"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "label"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "fieldType"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "formField"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "hidden"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "hubspotDefined"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "groupName"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "externalOptions"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "externalOptionsReferenceType"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "displayOrder"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "displayMode"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "description"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "calculated"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "objectTypeId"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "readOnlyDefinition"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "readOnlyValue"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "referencedObjectType"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "numberDisplayHint"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "mutableDefinitionNotDeletable"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "options"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "description"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "displayOrder"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "doubleData"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "hidden"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "label"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "readOnly"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "value"
                        }
                      }]
                    }
                  }]
                }
              }]
            }
          }, {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "Contact"
              }
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "defaultAssociations"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "toCompanies"
                    },
                    arguments: [{
                      kind: "Argument",
                      name: {
                        kind: "Name",
                        value: "first"
                      },
                      value: {
                        kind: "IntValue",
                        value: "1"
                      }
                    }],
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "edges"
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "node"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "id"
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "defaultProperties"
                                },
                                selectionSet: {
                                  kind: "SelectionSet",
                                  selections: [{
                                    kind: "Field",
                                    name: {
                                      kind: "Name",
                                      value: "name"
                                    },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [{
                                        kind: "Field",
                                        name: {
                                          kind: "Name",
                                          value: "id"
                                        }
                                      }, {
                                        kind: "Field",
                                        name: {
                                          kind: "Name",
                                          value: "value"
                                        }
                                      }]
                                    }
                                  }]
                                }
                              }]
                            }
                          }]
                        }
                      }]
                    }
                  }]
                }
              }]
            }
          }, {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "Ticket"
              }
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "pipelineInfo"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "pipeline"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "pipelineId"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "stages"
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "label"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "displayOrder"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "stageId"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "metadata"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "propertyValueRequirements"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "isValueRequired"
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "propertyName"
                                }
                              }]
                            }
                          }]
                        }
                      }]
                    }
                  }]
                }
              }]
            }
          }, {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "Deal"
              }
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "pipelineInfo"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "pipeline"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "pipelineId"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "stages"
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "label"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "displayOrder"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "stageId"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "metadata"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "propertyValueRequirements"
                            },
                            selectionSet: {
                              kind: "SelectionSet",
                              selections: [{
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "isValueRequired"
                                }
                              }, {
                                kind: "Field",
                                name: {
                                  kind: "Name",
                                  value: "propertyName"
                                }
                              }]
                            }
                          }]
                        }
                      }]
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
});
export const FETCH_ASSOCIATED_OBJECTS_CARD_ASSOCIATIONS = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"query\",\"name\":{\"kind\":\"Name\",\"value\":\"AssociatedObjectsCardAssociations\"},\"variableDefinitions\":[{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"unlabeledAssociationFilterGroups\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"ListType\",\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"FilterGroup\"}}}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"hasPrimaryAssociation\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Boolean\"}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"offset\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Int\"}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"pageSize\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Int\"}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"primaryAssociationFilterGroups\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"ListType\",\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"FilterGroup\"}}}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"sorts\"}},\"type\":{\"kind\":\"ListType\",\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Sort\"}}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"toObjectTypeId\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"String\"}}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"alias\":{\"kind\":\"Name\",\"value\":\"impliedUnlabeledAssociationObjects\"},\"name\":{\"kind\":\"Name\",\"value\":\"crmObjectsSearch\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"type\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"toObjectTypeId\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"filterGroups\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"unlabeledAssociationFilterGroups\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"count\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"pageSize\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"offset\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"offset\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"sorts\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"sorts\"}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"FetchAssociatedObjectsCardAssociationsCrmSearchPayload\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"crmObjectsSearch\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"type\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"toObjectTypeId\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"filterGroups\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"primaryAssociationFilterGroups\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"count\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"pageSize\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"offset\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"offset\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"sorts\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"sorts\"}}}],\"directives\":[{\"kind\":\"Directive\",\"name\":{\"kind\":\"Name\",\"value\":\"include\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"if\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"hasPrimaryAssociation\"}}}]}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"FragmentSpread\",\"name\":{\"kind\":\"Name\",\"value\":\"FetchAssociatedObjectsCardAssociationsCrmSearchPayload\"}}]}}]}}]}", {
  id: null,
  kind: "Document",
  definitions: _unique([{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "AssociatedObjectsCardAssociations"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "unlabeledAssociationFilterGroups"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "ListType",
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "FilterGroup"
              }
            }
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "hasPrimaryAssociation"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "Boolean"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "offset"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "Int"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "pageSize"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "Int"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "primaryAssociationFilterGroups"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "ListType",
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "FilterGroup"
              }
            }
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "sorts"
        }
      },
      type: {
        kind: "ListType",
        type: {
          kind: "NonNullType",
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "Sort"
            }
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "toObjectTypeId"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        alias: {
          kind: "Name",
          value: "impliedUnlabeledAssociationObjects"
        },
        name: {
          kind: "Name",
          value: "crmObjectsSearch"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "type"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "toObjectTypeId"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "filterGroups"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "unlabeledAssociationFilterGroups"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "count"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "pageSize"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "offset"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "offset"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "sorts"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "sorts"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "FetchAssociatedObjectsCardAssociationsCrmSearchPayload"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "crmObjectsSearch"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "type"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "toObjectTypeId"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "filterGroups"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "primaryAssociationFilterGroups"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "count"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "pageSize"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "offset"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "offset"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "sorts"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "sorts"
            }
          }
        }],
        directives: [{
          kind: "Directive",
          name: {
            kind: "Name",
            value: "include"
          },
          arguments: [{
            kind: "Argument",
            name: {
              kind: "Name",
              value: "if"
            },
            value: {
              kind: "Variable",
              name: {
                kind: "Name",
                value: "hasPrimaryAssociation"
              }
            }
          }]
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "FetchAssociatedObjectsCardAssociationsCrmSearchPayload"
            }
          }]
        }
      }]
    }
  }].concat(FETCH_ASSOCIATED_OBJECTS_CARD_ASSOCIATIONS_CRM_SEARCH_PAYLOAD_FRAGMENT.definitions))
});
export const FETCH_ASSOCIATED_OBJECTS_CARD_ALL_ASSOCIATION_TYPES_BETWEEN_OBJECT_IDS = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"query\",\"name\":{\"kind\":\"Name\",\"value\":\"AssociatedObjectsCardAllAssociationTypesBetweenObjectIds\"},\"variableDefinitions\":[{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"fromObjectId\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Long\"}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"fromObjectType\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"String\"}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"toObjectIds\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"ListType\",\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Long\"}}}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"toObjectType\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"String\"}}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"allAssociationTypesBetweenObjectIds\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"fromObjectId\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"fromObjectId\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"fromObjectType\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"fromObjectType\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"toObjectIds\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"toObjectIds\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"toObjectType\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"toObjectType\"}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"associationDefinitions\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"isPrimary\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"associationCategory\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"associationTypeId\"}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"toObjectId\"}}]}}]}}]}", {
  id: null,
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "AssociatedObjectsCardAllAssociationTypesBetweenObjectIds"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "fromObjectId"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "Long"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "fromObjectType"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "toObjectIds"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "ListType",
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "Long"
              }
            }
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "toObjectType"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "allAssociationTypesBetweenObjectIds"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "fromObjectId"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "fromObjectId"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "fromObjectType"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "fromObjectType"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "toObjectIds"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "toObjectIds"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "toObjectType"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "toObjectType"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "associationDefinitions"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "isPrimary"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "associationCategory"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "associationTypeId"
                }
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "toObjectId"
            }
          }]
        }
      }]
    }
  }]
});
export const FETCH_ASSOCIATED_OBJECTS_CARD_PROPERTY_DEFINITIONS = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"query\",\"name\":{\"kind\":\"Name\",\"value\":\"AssociatedObjectsCardPropertyDefinitions\"},\"variableDefinitions\":[{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"toObjectTypeId\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"String\"}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"properties\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"ListType\",\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"String\"}}}}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"objectTypeDefinition\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"objectType\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"toObjectTypeId\"}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"propertyDefinitions\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"names\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"properties\"}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"type\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"name\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"deleted\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"textDisplayHint\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"showCurrencySymbol\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"dataSensitivity\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"currencyPropertyName\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"label\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"fieldType\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"formField\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"hidden\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"hubspotDefined\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"groupName\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"externalOptions\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"externalOptionsReferenceType\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"displayOrder\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"displayMode\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"description\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"calculated\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"objectTypeId\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"readOnlyDefinition\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"readOnlyValue\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"referencedObjectType\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"numberDisplayHint\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"mutableDefinitionNotDeletable\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"options\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"description\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"displayOrder\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"doubleData\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"hidden\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"label\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"readOnly\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"value\"}}]}}]}}]}}]}}]}", {
  id: null,
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "AssociatedObjectsCardPropertyDefinitions"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "toObjectTypeId"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "properties"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "ListType",
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "String"
              }
            }
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "objectTypeDefinition"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "objectType"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "toObjectTypeId"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "propertyDefinitions"
            },
            arguments: [{
              kind: "Argument",
              name: {
                kind: "Name",
                value: "names"
              },
              value: {
                kind: "Variable",
                name: {
                  kind: "Name",
                  value: "properties"
                }
              }
            }],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "type"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "name"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "deleted"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "textDisplayHint"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "showCurrencySymbol"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "dataSensitivity"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "currencyPropertyName"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "label"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "fieldType"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "formField"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "hidden"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "hubspotDefined"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "groupName"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "externalOptions"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "externalOptionsReferenceType"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "displayOrder"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "displayMode"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "description"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "calculated"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "objectTypeId"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "readOnlyDefinition"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "readOnlyValue"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "referencedObjectType"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "numberDisplayHint"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "mutableDefinitionNotDeletable"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "options"
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "description"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "displayOrder"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "doubleData"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "hidden"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "label"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "readOnly"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "value"
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
});
export const FETCH_ASSOCIATED_OBJECTS_CARD_OBJECT = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"query\",\"name\":{\"kind\":\"Name\",\"value\":\"AssociatedObjectsCardObject\"},\"variableDefinitions\":[{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"objectType\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"String\"}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"objectId\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"Long\"}}}},{\"kind\":\"VariableDefinition\",\"variable\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"toObjectTypeId\"}},\"type\":{\"kind\":\"NonNullType\",\"type\":{\"kind\":\"NamedType\",\"name\":{\"kind\":\"Name\",\"value\":\"String\"}}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"crmObject\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"type\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"objectType\"}}},{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"objectId\"}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"id\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"primaryDisplayLabel\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"userPermissions\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"currentUserCanEdit\"}}]}}]}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"objectTypePermissions\"},\"arguments\":[{\"kind\":\"Argument\",\"name\":{\"kind\":\"Name\",\"value\":\"objectTypeId\"},\"value\":{\"kind\":\"Variable\",\"name\":{\"kind\":\"Name\",\"value\":\"toObjectTypeId\"}}}],\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"currentUserCanCreate\"}}]}}]}}]}", {
  id: null,
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "AssociatedObjectsCardObject"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "objectType"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "objectId"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "Long"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "toObjectTypeId"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "crmObject"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "type"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "objectType"
            }
          }
        }, {
          kind: "Argument",
          name: {
            kind: "Name",
            value: "id"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "objectId"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "primaryDisplayLabel"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "userPermissions"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "currentUserCanEdit"
                }
              }]
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "objectTypePermissions"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "objectTypeId"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "toObjectTypeId"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "currentUserCanCreate"
            }
          }]
        }
      }]
    }
  }]
});